import { NgModule } from '@angular/core';

import { PendoService } from './pendo.service';
import { SentryService } from './sentry/sentry.service';
import { getErrorHandlerProvider } from './sentry/sentry-error-handler';
import { GoogleTagManagerService } from './google-tag-manager.service';

@NgModule({
  providers: [getErrorHandlerProvider()],
})
export class ThirdPartyServicesModule {
  constructor(
    googleTagManagerService: GoogleTagManagerService,
    pendoService: PendoService,
    sentryService: SentryService
  ) {
    // inject SentryService to create and initialize it.
    // eslint-disable-next-line @typescript-eslint/no-empty-function
  }
}
